import { Box, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PropTypes from "prop-types";

const MetaItem = ({ label, value }) => (
  <Box>
    <Typography
      sx={{
        fontSize: "12px",
        color: "text.secondary",
        mb: 0.5,
      }}
    >
      {label}
    </Typography>
    <Typography
      sx={{
        fontSize: "14px",
        fontWeight: 700,
        color: "text.primary",
      }}
    >
      {value}
    </Typography>
  </Box>
);

MetaItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

const CommittedDateHeader = ({ data }) => {
  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        border: "1px solid #E5E7EB",
        borderRadius: "16px",
        p: 3,
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={1}
      >
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 700,
            letterSpacing: "0.06em",
            color: "text.secondary",
            textTransform: "uppercase",
          }}
        >
          COMMITTED DELIVERY DATE
        </Typography>

        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.75,
            px: 1.5,
            py: 0.5,
            borderRadius: "20px",
            backgroundColor: "#F9FAFB",
            border: "1px solid #E5E7EB",
          }}
        >
          <LockOutlinedIcon sx={{ fontSize: 14, color: "#4B5563" }} />
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: 500,
              color: "#374151",
            }}
          >
            Locked · does not change with masters
          </Typography>
        </Box>
      </Box>

      <Typography
        sx={{
          fontSize: { xs: "28px", sm: "36px" },
          fontWeight: 800,
          color: "#111827",
          lineHeight: 1.2,
          mt: 1.5,
        }}
      >
        {data.committedDeliveryDate}
      </Typography>

      <Typography
        sx={{
          fontSize: "13px",
          color: "text.secondary",
          mt: 0.5,
          mb: 3,
        }}
      >
        Frozen at order confirmation on {data.frozenAt}
      </Typography>

      <Box
        display="flex"
        flexWrap="wrap"
        gap={{ xs: 3, sm: 6 }}
        sx={{
          pt: 2,
        }}
      >
        <MetaItem label="Destination" value={data.destination} />
        <MetaItem label="Reference Id" value={data.reservation} />
      </Box>
    </Box>
  );
};

CommittedDateHeader.propTypes = {
  data: PropTypes.shape({
    committedDeliveryDate: PropTypes.string,
    frozenAt: PropTypes.string,
    destination: PropTypes.string,
    reservation: PropTypes.string,
  }),
};

export default CommittedDateHeader;
